import React, { useCallback, useState } from 'react';

import { Button } from '../Button/Button';

import classes from './cookies.module.scss';

export const CookiesModal = () => {
  const [isVisibleCookie, setIsVisibleCookie] = useState(true);

  const onCLickAcknowledge = useCallback(() => {
    setIsVisibleCookie(false);
    localStorage.setItem('cookie_acknowledge', true);
  }, []);

  return isVisibleCookie ? (
    <div className={classes.Cookie}>
      <div className={classes.CookieText}>
        This website uses cookies to ensure you get the best experience on our site. By continuing
        to use our website, you agree to our use of cookies.
      </div>
      <Button title="Acknowledge" type="primaryPurple" onClick={onCLickAcknowledge} />
    </div>
  ) : null;
};
